module.exports = __webpack_public_path__ + "static/media/left-chevron.d7f7de7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/left-chevron.svg
// module id = 1015
// module chunks = 0